import type { FaireProductEntity } from "../../entity_types/product";

export const p_9b5rfmqpdm: FaireProductEntity = {
  token: "p_9b5rfmqpdm",
  type: "product",
  name: "Oval Enamel Tray - Nomenclature of Colors",
  brandToken: "b_u89gdyfh23",
  brandName: "Roomytown Inc",
  imageUrl:
    "https://cdn.faire.com/fastly/971c901d4bf69d8221bbd11e375db985a2cb3f69b8666ee1c333f9097829a5e2.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/8c4ffab64253255660d0bca0ce35356d63b5b5591ac40c7661affe9576e8863d.jpeg",
    "https://cdn.faire.com/fastly/ef0c15ef395de8d43b57a0da267491845f3759c1252632efdf0c0bc076e29e23.jpeg",
  ],
  priceDollars: 13.5,
  description:
    "This decorative Nomenclature of Colors Printed Enamel Tray will bring instant personality into your home. Featuring artwork adapted from colour swatches ornithologist Robert Ridgway produced in 1886 to standardise names of colours of birds for naturalists, this Printed Enamel Tray is perfect for holding stationery, jewellery, and other trinkets. \n\nH 120mm x W 250mm x D 15mm / H 4.7” x W 9.8” x D 0.6”\n\n*Each of our enamel trays is expertly handcrafted in India. Due to the nature of this handmade production process, please expect some variation in the final product.\n\nExplore our wall prints and home decor, boasting charming designs for tea towels, trinket trays, playing cards, and notebooks. Embrace the upcoming seasons with delightful pieces perfect for gifting on occasions like Valentine's Day and Easter. Elevate your space with our unique home decor selections, capturing the essence of spring.\n\n Gifts For Her | Gifts for Him",
  tags: [],
  msrpDollars: 30,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-06-24T21:40:48.127Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
